import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import Modal from 'react-modal'
import '../styles/share-modal.scss'
// import API from '../../../api'
import { copyTextToClipboard } from '../../../utils'

const ShareModal = ({ title, isOpen, onClose }) => {
  const intl = useIntl()
  const modalStyles = {
    content: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  }

  const onCopyClick = () => {
    // this API requires authorization
    // API('url-shortner/')
    //   .post({
    //     longUrl: window.location.href,
    //   })
    //   .then((data) => copyTextToClipboard(data.shortUrl, true))

    copyTextToClipboard(window.location.href, true)
  }

  const messages = defineMessages({
    emailSubject: {
      id: 'share.email.subject',
      defaultMessage: 'Checkout this cool dive site - {siteTitle} ',
    },
    emailBody: {
      id: 'share.email.body',
      defaultMessage: 'Hi, This dive site - {url} looks pretty cool.',
    },
  })

  return (
    <Modal
      className='pm-modal'
      style={modalStyles}
      isOpen={isOpen}
      appElement={this}
      onRequestClose={onClose}
      contentLabel='Share modal'
      ariaHideApp={false}
    >
      <div className='dive-site-header__share-modal share-modal'>
        <button className='share-modal__close-btn' onClick={onClose}>
          &times;
        </button>
        <p className='share-modal__title'>{title}</p>
        <ul className='share-modal__list'>
          <li>
            <a
              className='share-modal__link'
              href={`https://www.facebook.com/sharer.php?u=${window.location.href}`}
              target='blank'
              rel='noreferrer'
              data-navigation-elements
              data-region-identifier='share'
            >
              <i className='font-icons fb-icon' />
              <span>Facebook</span>
            </a>
          </li>
          <li>
            <a
              className='share-modal__link'
              href={`https://twitter.com/intent/tweet?url=${window.location.href}`}
              target='blank'
              data-navigation-elements
              data-region-identifier='share'
              rel='noreferrer'
            >
              <i className='font-icons twitter-icon' />
              <span>Twitter</span>
            </a>
          </li>
          <li>
            <a
              className='share-modal__link'
              href={`mailto:
                    ?subject=${intl.formatMessage(messages.emailSubject, {
      siteTitle: title,
    })}
                    &body=${intl.formatMessage(messages.emailBody, {
      url: window.location.href,
    })}`}
              target='blank'
              data-navigation-elements
              data-region-identifier='share'
              rel='noopener noreferrer'
            >
              <i className='font-icons icon-email-new' />
              <span>Email</span>
            </a>
          </li>
          <li>
            <span className='share-modal__link' onClick={onCopyClick}>
              <i className='font-icons icon-link' />
              <FormattedMessage id='copy_link' defaultMessage='Copy link' />
            </span>
          </li>
        </ul>
      </div>
    </Modal>
  )
}

export default ShareModal
